import React from 'react'
import { Link } from 'react-router-dom'
import { wrapView } from '../smart_bps/lib/utils'
import { stateToProps } from '../smart_bps/bps/base_view'
import { PROJECT_NAME } from "./constants"
import { SigurListView } from '../lib/SigurListView'
import { Paginator } from '../smart_bps/lib/components'
import { format_attr_value } from '../smart_bps/lib/utils'
import { SigurModalOrderColumn } from '../common_components/modal_order_column'

class ListView extends SigurListView {
    renderModals() {
    let modals = [
      <SigurModalOrderColumn project_name={this.project_name}
      attrs={this.props.attrs}
      table_headers={this.props.table_headers}
      user_table_headers={this.props.user_table_headers} />
    ]

    return [...modals, ...(super.renderModals() || [])]
  }

  renderContent() {
    const table_headers = this.props.table_headers || ['name', 'is_in_blacklist']
    const attrs = this.props.attrs || {}

    function renderTh(attr_name) {
      const attr = attrs[attr_name] || { title: attr_name }
      return <th key={attr_name}>{attr.title}</th>
    }

    function renderTd(attr_name, row) {
      const value = row[attr_name]
      const attr = attrs[attr_name] || {}

      // Поле "Наименование" - гиперссылка на карточку
      if (attr_name === 'name') {
        return (
          <td key={attr_name}>
            <Link to={`/${PROJECT_NAME}/${row.id}/`}>{value || '—'}</Link>
          </td>
        )
      }

      // Поле "В черном списке": красная галочка (true), зеленый крестик (false).
      // Бэкенд в реестре отдаёт булевы поля как "Да"/"Нет", не true/false.
      if (attr_name === 'is_in_blacklist') {
        const inList = value === true || value === 'Да' || value === 1
        return (
          <td key={attr_name}>
            {inList ? (
              <i className="ti ti-check text-danger" title="В черном списке" aria-hidden />
            ) : (
              <i className="ti ti-x text-success" title="Не в черном списке" aria-hidden />
            )}
          </td>
        )
      }

      return <td key={attr_name}>{format_attr_value ? format_attr_value(attr, value) : value || '—'}</td>
    }

    function renderTr(row) {
      return (
        <tr key={row.id}>
          {table_headers.map((attr_name) => renderTd(attr_name, row))}
        </tr>
      )
    }

    if (!this.props.list_items || this.props.list_items.length === 0) {
      return (
        <div className="card mb-3">
          <div className="card-body p-3">Данные не найдены. Уточните условия отбора и поиска.</div>
        </div>
      )
    }

    return [
      <div className="card mb-3" key="table">
        <div className="table-responsive text-nowrap">
          <table className="table table-sm">
            <thead>
              <tr>{table_headers.map(renderTh)}</tr>
            </thead>
            <tbody className="table-border-bottom-0">{this.props.list_items.map(renderTr)}</tbody>
          </table>
        </div>
      </div>,

      <Paginator
        key="paginator"
        current_page={this.props.list_page}
        count_pages={this.props.list_count_pages}
        has_next={this.props.list_has_next_page}
        setPage={this.updateItems}
      />,
    ]
  }
}

export default wrapView(ListView, (state) => {
  return stateToProps(state, PROJECT_NAME)
})
